var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"mw-page-container\">\n<div class=\"mw-page-sub-menu\">\n<div class=\"mw-page-sub-menu-title ng-binding\">\nAnalytics\n</div>\n<ul class=\"mw-page-sub-menu-list\">\n<li ng-class=\"{active:state.current.name === sref}\" ng-repeat=\"(sref,title) in wizard.steps\" class=\"ng-binding ng-scope\">\n<a ui-sref=\"{{sref}}\">{{title}}</a>\n</li>\n</ul>\n</div>\n<div ui-view></div>\n</div>\n";
var id1="app/analytics/analytics-setting.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;